import genLinkParams from '@/lib/generateLinkParams'

/**
 * Resolves breadcrumb link the same way the visible Breadcrumbs UI does.
 * Schema.org BreadcrumbList must reuse these exact paths.
 */
export default function resolveBreadcrumbLink(item = {}) {
  if (item.link) {
    return { href: item.link, as: item.link }
  }

  const params = genLinkParams({
    type: item.type,
    slug: item.slug,
    parentSlug: item.parentSlug,
  })

  const href = params?.[0] || '/'
  const as = params?.[1] || href || '/'

  return { href, as }
}
